import { FormLabel, Tooltip, Typography } from "@material-ui/core";
import React from "react";
import { InfoOutlined } from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";

export type WTMToolTipProps = {
  label: string;
  tooltip: string;
};

const useStyles = makeStyles((theme) => ({
  formLabel: {
    marginBottom: -2,
    position: "relative" as "relative",
    textOverflow: "ellipsis",
    textTransform: "none",
    whiteSpace: "nowrap",
  },
  infoIcon: {
    fontSize: theme.spacing(2),
    marginBottom: 2,

    "&:hover": {
      cursor: "pointer",
    },
  },
}));

function FormLabelWithTooltip({ label, tooltip }: WTMToolTipProps) {
  const classes = useStyles();

  return (
    <FormLabel className={classes.formLabel}>
      <Typography variant="overline">{label}</Typography>{" "}
      <Tooltip title={tooltip} placement="top" arrow>
        <InfoOutlined className={classes.infoIcon} />
      </Tooltip>
    </FormLabel>
  );
}

export default FormLabelWithTooltip;
